import { render, staticRenderFns } from "./DepositAddTable.vue?vue&type=template&id=31e3648c"
import script from "./DepositAddTable.vue?vue&type=script&lang=js"
export * from "./DepositAddTable.vue?vue&type=script&lang=js"
import style0 from "./DepositAddTable.vue?vue&type=style&index=0&id=31e3648c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports